import React from 'react';
import { Loader2 } from 'lucide-react';

const LoadingSpinner = ({ size = 'default', text = 'Cargando...' }) => {
  const sizeClasses = {
    sm: 'w-4 h-4',
    default: 'w-6 h-6',
    lg: 'w-8 h-8',
    xl: 'w-12 h-12'
  };

  return (
    <div className="flex flex-col items-center justify-center space-y-3 py-8">
      <Loader2 className={`${sizeClasses[size]} animate-spin text-emerald-600`} />
      <p className="text-sm text-gray-600">{text}</p>
    </div>
  );
};

export default LoadingSpinner;